import React from 'react';

const ChevronLeft = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask id="mask0_5260_153041" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect x="24" y="24" width="24" height="24" transform="rotate(-180 24 24)" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5260_153041)">
        <path
          d="M15.3002 6.69922C15.4835 6.88255 15.5752 7.11589 15.5752 7.39922C15.5752 7.68255 15.4835 7.91589 15.3002 8.09922L11.4002 11.9992L15.3002 15.8992C15.4835 16.0826 15.5752 16.3159 15.5752 16.5992C15.5752 16.8826 15.4835 17.1159 15.3002 17.2992C15.1169 17.4826 14.8835 17.5742 14.6002 17.5742C14.3169 17.5742 14.0835 17.4826 13.9002 17.2992L9.3002 12.6992C9.2002 12.5992 9.1292 12.4909 9.0872 12.3742C9.04586 12.2576 9.0252 12.1326 9.0252 11.9992C9.0252 11.8659 9.04586 11.7409 9.0872 11.6242C9.1292 11.5076 9.2002 11.3992 9.3002 11.2992L13.9002 6.69922C14.0835 6.51589 14.3169 6.42422 14.6002 6.42422C14.8835 6.42422 15.1169 6.51589 15.3002 6.69922Z"
          fill="#969696"
        />
      </g>
    </svg>
  );
};

export default ChevronLeft;
